import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import { brand, brandAdmin, tokens } from '@/components/ds/tokens/tokens.js';

const onBrand = { 'on-success': '#FFFFFF', 'on-warning': '#FFFFFF', 'on-info': '#FFFFFF', 'on-error': '#FFFFFF' };
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  display: {
    mobileBreakpoint: 'sm', // กำหนด breakpoint สำหรับ mobile
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      // Both themes take their brand colours from the design tokens (components/ds/tokens/tokens.js) — change the
      // brand there, not here. Colours follow the design; the AA replacements for the display modes are CSS
      // overrides in dga-tokens.scss. White text on success / warning / info is the design (Vuetify would pick
      // black on the light green / orange).
      // Portal admin + SuperAdmin pages (App.vue appTheme): admin brand (Light.tokens.json, primary = deep-blue
      // #0A34A2) + DS surfaces. The rest of the admin colour set is the `.v-theme--dgaTheme` block in dga-tokens.scss.
      dgaTheme: {
        dark: false,
        colors: {
          ...brandAdmin,
          ...onBrand,
          surface: tokens.color.surface,
          background: tokens.color.background,
        },
      },
      // White-label routes (chat / FullStream / snippet / login / landing): same brand colours so
      // --dga-color-* tokens resolve to the DGA palette there too; Vuetify's default white surfaces are kept.
      // Company colours loaded at runtime (ConfigTheme / snippet settings) still override per page.
      light: {
        dark: false,
        colors: {
          ...brand,
          ...onBrand,
        },
      },
    },
  },
});

export default vuetify;
